import { ITableFiltersObject } from "@monorepo/utils/src/store/types/tableFiltersObject";
import { convertStatus } from "@monorepo/utils/src/api/convertDeleteStatus";
import { convertAutocompleteItemToApi } from "@monorepo/utils/src/api/convertFiltersToApi";
import { fields } from "@monorepo/utils/src/variables/projectsData/archiveView/fields";

const convertSortKey = (key: string): string => {
  switch (key) {
    case "status":
      return "isDeleted";
    default:
      return key;
  }
};

export const convertFiltersCustomToApi = (resultFilters: ITableFiltersObject & { fieldFilters: { status?: string } }): void => {
  convertStatus(resultFilters, "isDeleted");
  convertAutocompleteItemToApi(resultFilters, fields.ARCHIVE_CODE, `fieldFilters.${fields.ARCHIVE_CODE}.code`);
  convertAutocompleteItemToApi(resultFilters, fields.ARCHIVE_ID, `fieldFilters.${fields.ARCHIVE_ID}.id`);
  convertAutocompleteItemToApi(resultFilters, fields.ARCHIVE_NAME, `fieldFilters.${fields.ARCHIVE_NAME}.name`);
  convertAutocompleteItemToApi(resultFilters, fields.ARCHIVE_SHORT_NAME, `fieldFilters.${fields.ARCHIVE_SHORT_NAME}.shortName`);
  resultFilters.sort = Object.fromEntries(Object.entries(resultFilters.sort || {}).map(([key, value]) => [convertSortKey(key), value]));
};
